export const cluster = `
  rounded-[50%]
  bg-gradient-to-t from-ll-primary-variant1 to-ll-primary
  text-white
  flex
  justify-center
  items-center
  leading-none
  font-sans
  border-2
  border-solid
  border-white
  shadow-sm
  cursor-default
`;

export const clusterList = `
  list-none
  p-0
  m-0
`;

export const clusterListItem = `
  font-sans
  p-2
  bg-white
  rounded
  border
  border-solid
  border-ll-border
  cursor-default
  mb-1
  last:mb-0
  hover:bg-ll-surface
`;
